import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export default {
  map: css`
    background-color: ${colors.gray02};
    block-size: calc(100vh - var(--header-height, 0px) - var(--subHeader-height, 0px));
    flex-shrink: 0;
    inset-inline-start: 0;
    position: sticky;
  `,
  mapWrapper: css`
    block-size: 100%;
    &:focus {
      outline: 2px solid ${colors.blue60};
      outline-offset: 2px;
    }
  `,
}
